export default __webpack_public_path__ + "static/media/ownerrez_step3.e13d7de4.jpg";